import React, { useEffect, useState, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import axios from 'axios';

const AdminScan = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [result, setResult] = useState(null); 
  const [msg, setMsg] = useState('');
  const [manualCode, setManualCode] = useState('');
  
  const scannerRef = useRef(null); 

  useEffect(() => {
    if (isScanning && result === null) {
        const timer = setTimeout(() => { startCamera(); }, 100);
        return () => clearTimeout(timer);
    }
    // eslint-disable-next-line
  }, [isScanning, result]);

  const startCamera = () => {
    if (scannerRef.current) return;

    const html5QrCode = new Html5Qrcode("reader");
    scannerRef.current = html5QrCode;

    // --- CẤU HÌNH LỌC ---
    const config = { 
        fps: 20, 
        qrbox: { width: 300, height: 150 }, 
        aspectRatio: 1.0,
        // QUAN TRỌNG: Chỉ đọc CODE_128 (thẻ cứng) và EAN_13 (hàng hóa)
        // Việc này ngăn Camera đoán mò các định dạng khác gây sai số.
        formatsToSupport: [ 
            Html5QrcodeSupportedFormats.CODE_128,
            Html5QrcodeSupportedFormats.EAN_13,
            Html5QrcodeSupportedFormats.QR_CODE 
        ],
        experimentalFeatures: { useBarCodeDetectorIfSupported: true }
    };
    
    html5QrCode.start(
      { facingMode: "environment" }, 
      config, 
      (decodedText) => {
        // ==> BỘ LỌC CỨNG (CLIENT SIDE) <==
        // Nếu mã chứa ký tự lạ (không phải số), bỏ qua ngay lập tức
        if (!/^[0-9]+$/.test(decodedText)) {
            console.log("Bỏ qua mã rác:", decodedText);
            return; 
        }

        stopCamera();
        handleCheckIn(decodedText);
      },
      (errorMessage) => { }
    ).catch(err => {
      // Fallback
      html5QrCode.start({ facingMode: "user" }, config, (t)=>{stopCamera();handleCheckIn(t);}, ()=>{}).catch(e=>{
          setMsg('❌ Lỗi Camera. F5 lại!'); setIsScanning(false);
      });
    });
  };

  const stopCamera = () => {
    if (scannerRef.current) {
        scannerRef.current.stop().then(() => {
            scannerRef.current.clear();
            scannerRef.current = null;
            setIsScanning(false);
        }).catch(err => { setIsScanning(false); scannerRef.current = null; });
    } else { setIsScanning(false); }
  };

  const handleCheckIn = async (code) => {
    if (!code) return;
    
    // Validate lần cuối
    if (!/^[0-9]+$/.test(code)) {
        setResult('error');
        setMsg('❌ Mã không hợp lệ (Chứa ký tự lạ)');
        return;
    }

    setMsg('⏳ Đang xử lý: ' + code);
    try {
      const res = await axios.post('/api/checkin', { employee_code: code.trim() });
      setResult('success');
      setMsg('✅ ' + res.data.message);
      setManualCode('');
    } catch (err) {
      setResult('error');
      setMsg('❌ ' + (err.response?.data?.message || 'Lỗi'));
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: 20, maxWidth: 600, margin: '0 auto', fontFamily: 'Arial' }}>
      <h2>Admin Check-in</h2>

      {isScanning && (
        <div style={{ marginBottom: 20 }}>
            <p style={{fontSize: 12, color: '#ccc'}}>Chỉ nhận mã SỐ (Code 128 / QR)</p>
            <div id="reader" style={{ width: '100%', border: '2px solid #333', minHeight: '300px', background: '#000' }}></div>
            <button onClick={stopCamera} style={{marginTop: 15, padding: '10px 20px', background: '#dc3545', color: 'white', border: 'none', borderRadius: 5}}>Hủy</button>
        </div>
      )}

      {!isScanning && result === null && (
        <div style={{ padding: 40, background: '#e9ecef', borderRadius: 10, marginBottom: 20 }}>
            <p>Sẵn sàng quét</p>
            <button onClick={() => {setResult(null); setMsg(''); setIsScanning(true);}} style={{
                padding: '20px 40px', fontSize: '20px', fontWeight: 'bold',
                background: '#007bff', color: 'white', border: 'none', borderRadius: '8px', width: '100%',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>📷 BẮT ĐẦU</button>
        </div>
      )}

      {result !== null && (
        <div style={{ padding: 30, background: result === 'success' ? '#d4edda' : '#f8d7da', borderRadius: 10, marginBottom: 20 }}>
            <h2 style={{ color: result === 'success' ? '#155724' : '#721c24' }}>{msg}</h2>
            <button onClick={() => {setResult(null); setIsScanning(true);}} style={{
                marginTop: 20, padding: '15px 30px', fontSize: '18px', fontWeight: 'bold',
                background: '#28a745', color: 'white', border: 'none', borderRadius: '5px', width: '100%'
            }}>TIẾP TỤC ➡️</button>
             <div style={{marginTop: 15}}>
                <button onClick={() => {setResult(null); setIsScanning(false);}} style={{background:'transparent', border: 'none', textDecoration: 'underline'}}>Về màn hình chính</button>
            </div>
        </div>
      )}

      <hr style={{margin: '30px 0', opacity: 0.3}} />
      <div style={{ background: '#f8f9fa', padding: 15, borderRadius: 5 }}>
        <h4>Nhập tay</h4>
        <div style={{display: 'flex', gap: 10}}>
            <input value={manualCode} onChange={(e) => setManualCode(e.target.value)} placeholder="Nhập mã..." style={{flex: 1, padding: 10}} />
            <button onClick={() => handleCheckIn(manualCode)} style={{padding: '10px', background: '#6c757d', color: 'white', border: 'none', borderRadius: 5}}>Gửi</button>
        </div>
      </div>
    </div>
  );
};

export default AdminScan;
